// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605060826/js/" + chunkId + "." + {"44":"699a0a53","225":"b2f5f13f","481":"a997c7d4","486":"2f006da5","770":"9831131d"}[chunkId] + ".0.5163733047598016.chunk.js";
};